<template>
    <div class='colour-picker-container-placeholder'>
        <Placeholder class='colour-text-placeholder'/>
        <Placeholder class='colour-picker-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>

<style lang="scss" scoped>
.colour-picker-container-placeholder{
    display: flex;
    flex-direction: column;
    gap: 10px
}
.colour-text-placeholder{
    width: 35%; 
    height: 25px;
}

.colour-picker-placeholder{
    width: 80%; 
    height: 35px;
}
</style>